import React, { useEffect, useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { connect } from 'react-redux';
import { apiUrl } from '../../utils/consts';
import LogoComponent from '../Logo/LogoComponent';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import ProductCard from '../ProductCard/ProductCard';
import bannerImg from '../../img/Banner.jpg';
import { setShowCreateModal } from '../../redux/modules/show';
import './styles/store.scss';

const typeOptions = [
  { type: 'PRODUCT_TYPE', value: 'PRODUCTO', label: 'Productos' },
  { type: 'PRODUCT_TYPE', value: 'SERVICIO', label: 'Servicios' }
];

const categoryOptions = [
  { type: 'PRODUCTO', typeLabel: 'Productos', value: 'ACCESORIOS', label: 'Accesorios' },
  { type: 'PRODUCTO', typeLabel: 'Productos', value: 'ROPA', label: 'Ropa' },
  { type: 'PRODUCTO', typeLabel: 'Productos', value: 'COMESTIBLES_ALIMENTOS', label: 'Comestibles y alimentos' },
  { type: 'PRODUCTO', typeLabel: 'Productos', value: 'ARTESANIAS', label: 'Artesanías' },
  { type: 'PRODUCTO', typeLabel: 'Productos', value: 'PUBLICIDAD', label: 'Publicidad' },
  { type: 'PRODUCTO', typeLabel: 'Productos', value: 'OTROS', label: 'Otros' },
  { type: 'SERVICIO', typeLabel: 'Servicios', value: 'LOGISTICOS', label: 'Servicios logísticos' },
  { type: 'SERVICIO', typeLabel: 'Servicios', value: 'HOGAR', label: 'Servicios para el hogar' },
  { type: 'SERVICIO', typeLabel: 'Servicios', value: 'BELLEZA', label: 'Servicios de belleza' },
  { type: 'SERVICIO', typeLabel: 'Servicios', value: 'OTROS', label: 'Otros' },
];

function mapDispatchToProps(dispatch) {
  return {
    setShowCreateModal: show => dispatch(setShowCreateModal(show))
  };
}

function ConnectedStoreComponent(props) {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [productTypeExpanded, setProductTypeExpanded] = useState(true);
  const [productCategoryExpanded, setProductCategoryExpanded] = useState(true);
  const [productTypes, setProductTypes] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [citiesValue, setCitiesValue] = useState('');
  const [cities, setCities] = useState([]);

  const filteredProducts = products.filter(item => {

    const typeFilterIndex = productTypes.findIndex(type => type.value === item.productType);
    const typeFilter = productTypes.length === 0 || typeFilterIndex !== -1;

    const categories = productCategories.filter(category => category.type === item.productType);
    const categoryFilterIndex = categories.findIndex(category => category.value === item.productCategory && category.type === item.productType);
    const categoryFilter = categories.length === 0 || categoryFilterIndex !== -1;

    let citiesFilter = item.countryShipment || !cities || cities.length === 0;

    if (!citiesFilter) {
      const filterCityArr = cities.map(city => city.value);
      const productCityArr = item.shipmentCities.map(city => city.value);

      const intersection = filterCityArr.filter(city =>
        productCityArr.findIndex(city2 => city2.includes(city) || city.includes(city2)) !== -1
      );

      citiesFilter = intersection && intersection.length > 0;
    }

    return typeFilter && categoryFilter && citiesFilter;
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const productsProm = await fetch(`${apiUrl}/products/get`);
    const productsResp = await productsProm.json();

    if (productsResp.success) setProducts(productsResp.products.sort(() => 0.5 - Math.random()));

    setLoading(false);
  };

  const removeAllFilters = () => {
    setProductTypes([]);
    setProductCategories([]);
    setCitiesValue('');
    setCities([]);
  };

  const handleTypeFilterChange = filterValue => {
    const foundFilter = productTypes.find(item => item.type === filterValue.type && item.value === filterValue.value);

    if (foundFilter) {
      setProductTypes(productTypes.filter(item => item.value !== foundFilter.value || item.type !== foundFilter.type));
      setProductCategories(productCategories.filter(item => item.type !== foundFilter.value));
    } else {
      setProductTypes(productTypes.concat(filterValue));
    }
  };

  const handleCategoryFilterChange = filterValue => {
    const foundFilter = productCategories.find(item => item.type === filterValue.type && item.value === filterValue.value);

    if (foundFilter) setProductCategories(productCategories.filter(item => item.value !== foundFilter.value || item.type !== foundFilter.type));
    else {
      const typeIndex = productTypes.find(type => type.value === filterValue.type);
      if (!typeIndex) setProductTypes(productTypes.concat(typeOptions.find(type => type.value === filterValue.type)));

      setProductCategories(productCategories.concat(filterValue));
    }
  };

  const handleCityChange = value => {
    setCities(value);
  };

  const handleInputCityChange = value => {
    setCitiesValue(value);
  };

  const createOption = label => ({
    label,
    value: label.trim().toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  });

  const handleKeyDown = event => {

    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (citiesValue) {
          setCities([...cities, createOption(citiesValue) ]);
          setCitiesValue('');
        }

        event.preventDefault();

        break;
      default: return;
    }

  };

  const handleClickCreateProducts = () => {
    props.setShowCreateModal({ show: true, createModalTab: 0, hideTabs: true });
  };

  const handleClickStore = () => {
    const element = document.getElementById('storeList');
    if (element) window.scrollTo(0, element.offsetTop - 100);
  };

  return (
    <div className="store-component">
      <div className="app-banner" style={{ backgroundImage: `url("${bannerImg}")` }}>
        <LogoComponent />
        <div style={{ marginTop: '20vh' }}>
          <div className="nav-options">
            <div style={{ display: 'inline-block' }}>
              <div className={`app-nav-button`} onClick={handleClickCreateProducts} style={{ borderTopRightRadius: '0', borderBottomRightRadius: '0' }}>
                <span>¿eres emprendedor?</span>
              </div>
            </div>
            <div style={{ display: 'inline-block' }}>
              <div className={`app-nav-button`} onClick={handleClickStore} style={{ borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}>
                <span>deseas comprar</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Container fluid className="app-list-container" id="storeList">
        <Row noGutters>
          <Col md={2}>
            <div className="filterSidebar">
              <div style={{ marginBottom: '20px' }}>
                <span className="filterTitle">Filtra por:</span>
                <span className="removeFiltersBtn" onClick={removeAllFilters}>Quitar filtros</span>
              </div>

              <div className="filterSidebarTitle" style={{ cursor: 'default' }}>
                <span>Ciudad</span>
              </div>

              <CreatableSelect
                components={{ DropdownIndicator: null }}
                inputValue={citiesValue}
                onChange={handleCityChange}
                onInputChange={handleInputCityChange}
                onKeyDown={handleKeyDown}
                placeholder="Escribe una ciudad y coloca enter..."
                value={cities}
                menuIsOpen={false}
                isMulti
                isClearable
              />

              <div className="filterSidebarTitle" onClick={() => setProductTypeExpanded(!productTypeExpanded)}>
                <span>Tipo</span>
                <i className={productTypeExpanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'} />
              </div>
              {
                productTypeExpanded &&
                typeOptions.map((item, index) =>
                  <Form.Check
                    key={index}
                    type='checkbox'
                    id={`type-${item.value}`}
                    label={item.label}
                    checked={productTypes.findIndex(checkedType => checkedType.value === item.value) !== -1}
                    onChange={() => handleTypeFilterChange(item)}
                  />
                )
              }

              <div className="filterSidebarTitle" onClick={() => setProductCategoryExpanded(!productCategoryExpanded)}>
                <span>Categorías</span>
                <i className={productCategoryExpanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'} />
              </div>
              {
                productCategoryExpanded &&
                <div style={{ paddingLeft: '5px' }}>
                {
                  categoryOptions.map((category, index) =>
                    <div key={index}>
                      {
                        (index === 0 || category.type !== categoryOptions[index - 1].type) &&
                        <div className="filterSidebarTitle" style={{ cursor: 'default' }}>
                          <span>{category.typeLabel}</span>
                        </div>
                      }
                      <Form.Check
                        type='checkbox'
                        id={`category-${category.type}-${category.value}`}
                        label={category.label}
                        checked={productCategories.findIndex(checkedCategory => checkedCategory.type === category.type && checkedCategory.value === category.value) !== -1}
                        onChange={() => handleCategoryFilterChange(category, productCategories, setProductCategories)}
                      />
                    </div>
                  )
                }
                </div>
              }
            </div>
          </Col>
          <Col md={10}>
            <div className="results-column">
              {
                loading ?
                <AppSpinner /> :
                <Row>
                  {
                    filteredProducts.map(item =>
                      <Col sm={4} key={item._id}>
                        <ProductCard product={item} />
                      </Col>
                    )
                  }
                </Row>
              }
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const StoreComponent = connect(null, mapDispatchToProps)(ConnectedStoreComponent);

export default StoreComponent;
